import CustomLayout from "./wrapPageElement"

export const wrapPageElement = CustomLayout
// You can delete this file if you're not using it
